import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    fontFamily: 'Anton',
    fontStyle: 'italic',
  },
  bluebar: {
    background: "#0510e6",
  },
}));

export default function BasicAppBar() {
  const classes = useStyles();
  //  const preventDefault = (event) => event.preventDefault();

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.bluebar}>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MonetizationOnIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            iBetU
          </Typography>
          <Button color="inherit">
            <Link 
                href="/signup" 
                //  onClick={preventDefault}
                color="inherit"
            >SIGN UP</Link>
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
